import React from 'react'
import MaterialSymbol from '../material-symbol'

const Link = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="link" {...props} />
))

Link.displayName = 'Link'

export default Link
